import { render } from "./DepositoDuration.vue?vue&type=template&id=34f86d60"
import script from "./DepositoDuration.vue?vue&type=script&lang=js"
export * from "./DepositoDuration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__